import React from 'react'
import i18next, { changeLanguage } from 'i18next'

import './dev-actions.pcss'

const DevActions = () => {
    return (
        <div className="dev-actions">
            <button
                onClick={() => {
                    window.__i18n_xrayPluginEnabled = !window.__i18n_xrayPluginEnabled
                    changeLanguage(i18next.language) // this will trigger re-render
                }}
            >
                {window.__i18n_xrayPluginEnabled ? 'Disable translation tooltips' : 'Enable translation tooltips'}
            </button>
        </div>
    )
}

export default DevActions
